'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

var _selectors = require('./selectors');

var _selectors2 = _interopRequireDefault(_selectors);

var _constants = require('./constants');

var _timingUtils = require('./timingUtils');

var TimingUtils = _interopRequireWildcard(_timingUtils);

var _hubspot = require('hubspot');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _Raven = require('Raven');

var _Raven2 = _interopRequireDefault(_Raven);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MAX_INTERVAL = 250;
var START_INTERVAL = 25;
var TIMEOUT = 60000;
var SLOW_PAGE_START = 45000;

// Interval is what the last interval was
// Duration is how long the last check took
var BACKOFF_RULE = function BACKOFF_RULE(interval, duration) {
  return Math.max(1.5 * interval, duration * 5);
};

var debug = function debug(firstString) {
  for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  if (_enviro2.default.debug('reagan')) {
    var _console;

    (_console = console).log.apply(_console, ['[Reagan] ' + firstString].concat(rest));
  }
};

// Pulled from _.uniqueId()
var idCounter = 0;
var uniqueId = function uniqueId() {
  return '' + ++idCounter;
};

var sendAlert = function sendAlert(route, failures) {
  try {
    if (failures.length > 0) {
      var exceptions = window.Q && typeof window.Q.getUnhandledReasons === 'function' ? window.Q.getUnhandledReasons().map(function (exception) {
        if (exception) {
          if (typeof exception === 'string') {
            return exception;
          } else {
            return exception.message || exception.responseText || exception.statusText;
          }
        }
        return undefined;
      }) : [];

      var marksArray = window.performance && typeof window.performance.getEntriesByType === 'function' ? window.performance.getEntriesByType('mark') : [];

      var marks = marksArray.map(function (_ref) {
        var name = _ref.name,
            startTime = _ref.startTime;

        return { name: name, startTime: startTime };
      });

      var blockingModules = _hubspot2.default.getBlockingModules();

      // Not sending hubspot.getDeferredModules(), because that often causes the payload
      // to be too big and silently fail with a 414 Request-URI Too Large error.
      // (The max Sentry GET URL size seems to be ~7300 chars)

      var failureNames = Array.from(failures).map(function (failure) {
        return failure.name;
      }).join(',');

      var msg = 'Reagan failure loading ' + failureNames + ' on ' + route;

      if (_Raven2.default) {
        _Raven2.default.captureMessage(msg, {
          logger: 'Reagan',
          tags: {
            environment: _enviro2.default.getShort('reagan'),
            deployed: _enviro2.default.deployed('reagan')
          },
          extra: {
            hash: window.location.hash,
            blockingModules: blockingModules,
            erroredModules: typeof _hubspot2.default.getErroredModules === 'function' ? _hubspot2.default.getErroredModules() : undefined,
            exceptions: exceptions,
            marks: marks,
            failureNames: failureNames,
            time: TimingUtils.millisecondsSinceNavigationStart()
          }
        });
      }
    }
  } catch (e) {
    console.error(e);
  }
};

var Reagan = function () {
  function Reagan(options) {
    _classCallCheck(this, Reagan);

    this._markUserTiming = this._markUserTiming.bind(this);
    this._finishCheck = this._finishCheck.bind(this);
    if (options == null) {
      options = {};
    }
    this.maxInterval = options.maxInterval != null ? options.maxInterval : MAX_INTERVAL;
    this.startInterval = options.startInterval != null ? options.startInterval : START_INTERVAL;
    this.timeout = options.timeout != null ? options.timeout : TIMEOUT;
    this.slowPageStart = options.slowPageStart != null ? options.slowPageStart : SLOW_PAGE_START;

    // Attempt to strip awkwardly large timings, particularly those that we've discovered were from a
    // GoogleBot which does batched rendering of pages, causing unrealistic window.performance values.
    // Some info in https://productforums.google.com/forum/#!topic/webmasters/NpT02ib1EV0;context-place=topicsearchin/webmasters/category$3A(crawling-indexing--ranking)
    this.abnormalBehaviorThreshold = this.timeout * 10; // TODO, hoping to revisit and lower to 3x

    this.checkInProgress = false;
    this.hasFinishedCheck = false;

    this.stats = {
      numChecksStarted: 0,
      numChecksSuccessful: 0,
      numChecksFailed: 0,
      numChecksAborted: 0,
      abortedDurations: []
    };

    if (this.timeout - this.slowPageStart < 1000) {
      throw new Error('The Reagan slowPageStart (' + this.slowPageStart + ') should be at least 1-2 seconds greater than timeout (' + this.timeout + ').');
    }

    if (window.newrelic && window.newrelic.setCustomAttribute) {
      window.newrelic.setCustomAttribute('reaganVersion', _constants.REAGAN_MAJOR_VERSION);
    }

    this.startContentReadyTimeout();

    this.testTimeouts = {};
  }

  // Set some User Timing Marks (for Speedcurve, chrome timeline, etc)


  _createClass(Reagan, [{
    key: '_markUserTiming',
    value: function _markUserTiming(name, state) {
      if (window.performance && typeof window.performance.mark === 'function') {
        var markName = 'mark_' + name + '_' + state;
        window.performance.mark(markName);

        var entry = window.performance.getEntriesByName(markName)[0];

        if (entry) {
          return entry.startTime;
        }

        return -1;
      }

      return null;
    }
  }, {
    key: '_finishCheck',
    value: function _finishCheck(state, payload) {
      this.checkInProgress = false;
      clearTimeout(this.currentTestWatchdog);

      var reaganEventName = void 0;
      var duration = void 0;

      if (state === 'success') {
        duration = this._markUserTiming('all', 'success');

        reaganEventName = 'Reagan.success';

        this.stats.numChecksSuccessful += 1;
        this.hasFinishedCheck = true;
      } else if (state === 'failure') {
        duration = this._markUserTiming('all', 'failure');

        reaganEventName = 'Reagan.failure';

        this.stats.numChecksFailed += 1;
        this.hasFinishedCheck = true;
      } else if (state === 'abort') {
        reaganEventName = 'Reagan.abort';

        this.stats.numChecksAborted += 1;
        var timeBeforeAborted = TimingUtils.millisecondsSinceNavigationStart() - this.lastCheckStartedAt;
        this.stats.abortedDurations.push(timeBeforeAborted);
      } else {
        throw Error('Invalid finish state: ' + state);
      }

      var reaganEvent = document.createEvent('CustomEvent');
      reaganEvent.initCustomEvent(reaganEventName, true, true, payload);
      document.dispatchEvent(reaganEvent);

      return duration;
    }
  }, {
    key: '_hasAnySelectorValuesFor',
    value: function _hasAnySelectorValuesFor(params) {
      if (params != null) {
        return Object.keys(params).some(function (key) {
          var value = params[key];
          return value && value.length;
        });
      }

      return false;
    }
  }, {
    key: 'check',
    value: function check(route, params, options) {
      var _this = this;

      if (options == null) {
        options = {};
      }
      this.stopTimeoutForCheckNeverBeingCalled();

      try {
        var hasAnySuccessSelectors = params && params.success ? this._hasAnySelectorValuesFor(params.success) : params && params.error ? false : this._hasAnySelectorValuesFor(params);

        var hasAnyErrorSelectors = params && params.success ? this._hasAnySelectorValuesFor(params.error) : false;

        this.checkInProgress = true;
        this.lastCheckStartedAt = TimingUtils.millisecondsSinceNavigationStart();
        this.stats.numChecksStarted += 1;

        // Keep track of the page loads in new relic that don't have Reagan seletors setup
        if (window.newrelic && window.newrelic.setCustomAttribute) {
          window.newrelic.setCustomAttribute('hasReaganSuccessSelectors', hasAnySuccessSelectors);
          window.newrelic.setCustomAttribute('hasReaganErrorSelectors', hasAnyErrorSelectors);
          window.newrelic.setCustomAttribute('numReaganChecksStarted', this.stats.numChecksStarted);

          // Note calling these NR custom attributes "previous" because the Reagan check likely will
          // finish _after_ the NR BrowserInteraction/PageAction event is sent (so we're only tracking
          // the number of finished checks that occured before this check started)
          window.newrelic.setCustomAttribute('numPreviousReaganChecksAborted', this.stats.numChecksAborted);
          window.newrelic.setCustomAttribute('numPreviousReaganChecksFailed', this.stats.numChecksFailed);
          window.newrelic.setCustomAttribute('numPreviousReaganChecksSuccessful', this.stats.numChecksSuccessful);

          if (this.stats.abortedDurations && this.stats.abortedDurations.length > 0) {
            var avgAbortDuration = this.stats.abortedDurations.reduce(function (total, current) {
              return total + current / _this.stats.abortedDurations.length;
            }, 0);

            window.newrelic.setCustomAttribute('avgDurationBeforePreviousReaganAborts', avgAbortDuration);
          }
        }

        if (!params) {
          return;
        }

        var reaganEvent = document.createEvent('CustomEvent');
        reaganEvent.initCustomEvent('Reagan.start', true, true, {
          route: route,
          params: params
        });
        document.dispatchEvent(reaganEvent);

        if (options.startTimerOnPageLoad == null) {
          options.startTimerOnPageLoad = true;
        }

        var forDebugStr = '(for ' + route + ' route change)';

        if (options.startTimerOnPageLoad) {
          forDebugStr = '(for ' + route + ' page load)';
        } else if (!this.hasFinishedCheck) {
          forDebugStr = '(for ' + route + ' load, including some extra route changes)';
        }

        var selectors = new _selectors2.default(params);

        var selectorsToFind = selectors.getToCheck();

        if (selectorsToFind.length > 0) {
          selectorsToFind.forEach(function (_ref2) {
            var name = _ref2.name,
                successSelector = _ref2.successSelector,
                failureSelector = _ref2.failureSelector;

            debug('Awaiting %c\'' + name + '\' (' + (successSelector || failureSelector) + ')%c to be %cpresent%c ' + forDebugStr, 'font-weight: bold', 'font-weight: normal', 'font-weight: bold; color: blue', 'font-weight: normal; color: black');
          });
        } else {
          debug('%cNo selectors set%c for ' + forDebugStr + '. Please add a success selector.', 'font-weight: bold; color: red', 'font-weight: normal; color: black');
        }

        var interval = this.startInterval;

        // How long the last check took, we begin it at a reasonable default
        var checkDuration = 5;

        var currentTestTimeout = null;

        // We use an id to make sure we only keep the most current
        // timeout in the testTimeouts object.
        var checkId = uniqueId();

        var check = function check() {
          var checkStart = TimingUtils.now();

          var notFound = selectors.getToCheck();

          notFound.forEach(function (_ref3) {
            var name = _ref3.name,
                successSelector = _ref3.successSelector,
                failureSelector = _ref3.failureSelector;

            var successElementsFound = document.querySelectorAll(successSelector);
            var failureElementsFound = document.querySelectorAll(failureSelector);

            if (successSelector != null && successElementsFound.length > 0) {
              var duration = _this._markUserTiming(name, 'success');
              debug('%c\'' + name + '\'%c check %csucceeded%c ' + forDebugStr + ' in %c' + duration + ' ms%c', 'font-weight: bold', 'font-weight: normal', 'font-weight: bold; color: green', 'font-weight: normal; color: black', 'font-weight: bold; color: green', 'font-weight: normal; color: black', successElementsFound[0]);
              selectors.found(name, true);
            } else if (failureSelector != null && failureElementsFound.length > 0) {
              _this._markUserTiming(name, 'failure');
              debug('%c\'' + name + '\'%c check %cfailed%c ' + forDebugStr, 'font-weight: bold', 'font-weight: normal', 'font-weight: bold; color: red', 'font-weight: normal; color: black', failureElementsFound[0]);
              selectors.found(name, false);
            } else {
              selectors.checked(name);
            }
          });

          var failures = selectors.getFailed();

          // Immediately fail if there were any error selectors matched
          if (failures.length > 0) {
            debug('%cTriggering Reagan errorSelector failure%c (for ' + route + ', failed error check = %c' + (failures[0] != null ? failures[0].name : undefined) + '%c)', 'font-weight: bold; color: red;', 'font-weight: normal; color: black;', 'font-weight: bold;', 'font-weight: normal;');

            failures.forEach(function (_ref4) {
              var name = _ref4.name,
                  numChecks = _ref4.numChecks;

              if (window.newrelic) {
                window.newrelic.addPageAction('errorSelector', {
                  selector: name,
                  numChecks: numChecks
                });
              }
            });

            _this.sendReaganPageActionToNewRelic('reaganFinished', {
              status: 'failure',
              failureType: 'errorSelector',
              selector: failures[0] != null ? failures[0].name : undefined // only send the first failed selector?
            });

            _this._finishCheck('failure', { route: route, failures: failures });
            sendAlert(route, failures);
          } else if (selectors.isFinished()) {
            _this.sendReaganPageActionToNewRelic('reaganFinished', {
              status: 'success'
            });

            var duration = _this._finishCheck('success');
            debug('%cTriggering Reagan success%c ' + forDebugStr + ' in %c' + duration + ' ms%c', 'font-weight: bold; color: green;', 'font-weight: normal; color: black;', 'font-weight: bold; color: green;', 'font-weight: normal; color: black;');
          } else {
            interval = Math.min(_this.maxInterval, Math.floor(BACKOFF_RULE(interval, checkDuration)));
            currentTestTimeout = setTimeout(check, interval);
            _this.testTimeouts[checkId] = currentTestTimeout;
          }

          return checkDuration = TimingUtils.now() - checkStart;
        };

        // Report a "watchdogFailure", aka all selectors are not found within TIMEOUT
        var watchdogFailure = function watchdogFailure() {
          var notFound = selectors.getToCheck();

          notFound.forEach(function (_ref5) {
            var name = _ref5.name,
                numChecks = _ref5.numChecks;

            debug('\'' + name + '\' check %ctimed out%c after ' + TIMEOUT / 1000 + 's ' + forDebugStr, 'color: red', 'color: black');
            _this._markUserTiming(name, 'failure.watchdogExpired');
            if (window.newrelic) {
              window.newrelic.addPageAction('watchdogExpired', {
                selector: name,
                numChecks: numChecks
              });
            }
          });

          debug('Triggering %cReagan watchdogExpired failure%c ' + forDebugStr, 'font-weight: bold; color: red;', 'font-weight: normal; color: black;');
          _this.sendReaganPageActionToNewRelic('reaganFinished', {
            status: 'failure',
            failureType: 'watchdogExpired'
          });

          _this._markUserTiming('all', 'failure_watchdog_expired');
          _this._finishCheck('failure', { route: route, failures: notFound });
          return sendAlert(route + '.watchdogExpired', notFound);
        };

        var watchdog = function watchdog() {
          clearTimeout(currentTestTimeout);
          return watchdogFailure();
        };

        var giveUpAfter = this.timeout - TimingUtils.millisecondsSinceNavigationStart();

        if (!options.startTimerOnPageLoad || giveUpAfter == null || giveUpAfter > this.timeout) {
          giveUpAfter = this.timeout;
        }

        this.currentTestWatchdog = setTimeout(watchdog, giveUpAfter);
        check();
        this.testTimeouts[uniqueId()] = this.currentTestWatchdog;
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: 'startContentReadyTimeout',
    value: function startContentReadyTimeout() {
      var _this2 = this;

      var millisElapsed = TimingUtils.millisecondsSinceNavigationStart();
      var timeLeftForSlowStart = Math.max(0, this.slowPageStart - millisElapsed);

      this.alreadySendContentReadyFailure = false;

      // Timeout to ensure content ready is called, even if check is never called
      return this.contentReadyTimeout = setTimeout(function () {
        _this2.sendContentReadyFailure();
        return _this2.stop();
      }, timeLeftForSlowStart);
    }
  }, {
    key: 'sendContentReadyFailure',
    value: function sendContentReadyFailure() {
      // Prevent a case from sending duplicate failures when the first reagan check
      // never happens until _after_ the "unknown" contentReady failure was sent
      if (this.alreadySendContentReadyFailure) {
        return;
      }

      this.alreadySendContentReadyFailure = true;
      this.stopTimeoutForCheckNeverBeingCalled(); // just in case

      debug('Triggering %ccontentReady failure%c after ' + SLOW_PAGE_START / 1000 + 's (for unknown page load)', 'font-weight: bold; color: red;', 'font-weight: normal; color: black;');
      this.sendReaganPageActionToNewRelic('reaganFinished', {
        status: 'failure',
        failureType: 'contentReady'
      });

      this._markUserTiming('all', 'failure_content_ready');
      this._finishCheck('failure', { route: 'unknown-route' });
    }
  }, {
    key: 'sendReaganPageActionToNewRelic',
    value: function sendReaganPageActionToNewRelic(actionName, attrs) {
      // Only send the first successful/failed page load/route change to New Relic (not every route change... yet)
      if (this.hasFinishedCheck) {
        return;
      }

      try {
        if ((window.newrelic != null ? window.newrelic.addPageAction : undefined) != null) {
          if ((window.hubspot != null ? window.hubspot.getHttpRequestStatsByState : undefined) != null) {
            var succeededRequests = window.hubspot.getHttpRequestStatsByState('succeeded');
            var failedRequests = window.hubspot.getHttpRequestStatsByState('failed');
            var abortedRequests = window.hubspot.getHttpRequestStatsByState('aborted');
            var pendingRequests = window.hubspot.getHttpRequestStatsByState('pending');
            var timedOutRequests = window.hubspot.getHttpRequestStatsByState('timedOut');

            var failedRequestsMinus404AndRetries = failedRequests.filter(function (r) {
              return r.status !== 404 && !r.willBeRetried;
            });

            // Number of successful requests
            attrs.numSucceededRequests = succeededRequests.length;

            // Number requests aborted by the client (`xhr.abort()`)
            attrs.numAbortedRequests = abortedRequests.length;

            // Number of requests that haven't fully responded yet (that may succeed or fail)
            attrs.numPendingRequests = pendingRequests.length;

            // Number of 404s
            attrs.numNotFound = failedRequests.filter(function (r) {
              return r.status === 404;
            }).length;

            // Number of requests that failed with client-side timeout
            attrs.numTimedoutRequests = timedOutRequests.length;

            // Number of failed requests that were not 404s or timeouts (and exclude retries)
            attrs.numFailedRequestsMinus404AndRetries = failedRequestsMinus404AndRetries.length;

            // Number of retries that failed. So if there was one request that spawned two retries, only
            // one of those requests would show up in `numFailedRequestsMinus404AndRetries` and two retries
            // would show up in `numRetriedFailures`
            attrs.numRetriedFailures = failedRequests.filter(function (r) {
              return !!r.willBeRetried;
            }).length;

            var MAX_URLS = 10;

            if (failedRequestsMinus404AndRetries.length > 0) {
              attrs.failedRequestUrls = JSON.stringify(failedRequestsMinus404AndRetries.slice(0, MAX_URLS).map(function (r) {
                return r.url;
              }));
            }

            if (timedOutRequests.length > 0) {
              attrs.timedOutRequestUrls = JSON.stringify(timedOutRequests.slice(0, MAX_URLS).map(function (r) {
                return r.url;
              }));
            }

            if (pendingRequests.length > 0) {
              attrs.pendingRequestUrls = JSON.stringify(pendingRequests.slice(0, MAX_URLS).map(function (r) {
                return r.url;
              }));
            }
          }

          if (window.newrelic) {
            if (TimingUtils.millisecondsSinceNavigationStart() < this.abnormalBehaviorThreshold) {
              window.newrelic.addPageAction(actionName, attrs);
            } else {
              window.newrelic.addPageAction('reaganFinishedAbnormally', attrs);
            }
          }
        }
      } catch (e) {
        console.warn('Error trying to send XHR stats to New relic', e);
      }
    }
  }, {
    key: 'stopTimeoutForCheckNeverBeingCalled',
    value: function stopTimeoutForCheckNeverBeingCalled() {
      clearTimeout(this.contentReadyTimeout);
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.stopTimeoutForCheckNeverBeingCalled();

      for (var id in this.testTimeouts) {
        if (this.testTimeouts.hasOwnProperty(id)) {
          var timeout = this.testTimeouts[id];
          clearTimeout(timeout);
        }
      }

      if (this.checkInProgress) {
        this._finishCheck('abort');
      }

      return this.testTimeouts = {};
    }
  }]);

  return Reagan;
}();

// Critically important aliases:


Reagan.prototype.elect = Reagan.prototype.check;
Reagan.prototype.impeach = Reagan.prototype.stop;

exports.default = Reagan;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/Reagan/static-7.39/js/reagan.js
// module id = 1287
// module chunks = 3